<template>

  <div class="fill-height position-relative" v-resize="resize">

    <l-map
      ref="mainMap"
      :style="mapElStyle"
      :zoom.sync="zoom"
      :center.sync="center"
      :min-zoom="7"
      @ready="mapReady"
      @moveend="updateMapQueryParams"
      @locationfound="handleLocationFound"
      @click="handleMapClick"
      v-resize="resize"
      :options="{zoomControl: false, }"
    >

      <slot></slot>

      <l-control-zoom></l-control-zoom>
      <l-control-scale position="bottomleft" v-if="scale"></l-control-scale>

      <!--      <l-control>-->
      <!--        <v-card>-->
      <!--          <pre>{{mapScale}}</pre>-->
      <!--        </v-card>-->
      <!--      </l-control>-->

      <l-tile-layer
        url="http://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
        detect-retina :opacity="1.0" :z-index="1" :attribution="attribution"></l-tile-layer>

      <!--  <l-tile-layer-->
      <!--        url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"-->
      <!--        detect-retina :opacity="1.0" :z-index="1" :attribution="attribution"></l-tile-layer>-->

      <!--      <l-layer-group :visible="mapScale === 'small'" v-if="!disableBasemapStack">-->
      <!--        <l-tile-layer-->
      <!--          url="http://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}"-->
      <!--          detect-retina :opacity="1.0" :z-index="1" :attribution="attribution"></l-tile-layer>-->
      <!--        <l-tile-layer-->
      <!--          url="http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}"-->
      <!--          detect-retina :opacity="1.0" :z-index="3" :attribution="attribution"></l-tile-layer>-->
      <!--        <l-tile-layer-->
      <!--          url="http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"-->
      <!--          detect-retina :opacity="0.8" :z-index="2" :attribution="attribution"></l-tile-layer>-->
      <!--      </l-layer-group>-->

      <!--      <l-layer-group :visible="mapScale === 'medium'" v-if="!disableBasemapStack">-->
      <!--        <l-tile-layer-->
      <!--          url="http://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"-->
      <!--          detect-retina :opacity="1.0" :z-index="1" :attribution="attribution"></l-tile-layer>-->
      <!--      </l-layer-group>-->

      <!--      <l-layer-group :visible="mapScale === 'large'" v-if="!disableBasemapStack">-->
      <!--        <l-tile-layer-->
      <!--          url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"-->
      <!--          detect-retina :opacity="1.0" :z-index="1" :attribution="attribution"></l-tile-layer>-->
      <!--      </l-layer-group>-->

      <l-marker v-if="identifyPoint"
                ref="identifyPointComponent"
                :lat-lng="identifyPoint"
                @ready="identifyPointComponentReady"
                :icon="pulseIcon"
      ></l-marker>

      <IdentifyService v-if="useIdentify"
                       @center-on-identify="centerOnIdentifyPoint"></IdentifyService>

    </l-map>

    <div v-if="symbols && legend">
      <div class="position-absolute spin"
           style="top: 10px; right: 10px; z-index: 3000; opacity: 0.9">
        <div class="leaflet-bar" style="pointer-events: none !important;">
          <div class="pa-2 white">
            <!--            <h6 class="subtitle-1" style="border-bottom: 1px solid lightgrey;">Legend</h6>-->
            <h6 class="font-xs-small grey--text ">Speed (Mbps)</h6>
            <div v-for="(s,i) in symbols"
                 :key="i"
                 class="text-center"
                 :style="{ backgroundColor: getSymbolColor(s[0].symbol.color) }">
              <div class="my-1 pa-1 font-xs-small" v-if="s[0].label !== '<Null>'">
                {{s[0].label}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import { GeoJSON } from 'leaflet';

import { FeatureGroup, DomUtil, Marker, DivIcon } from 'leaflet';
import { DynamicMapLayer, FeatureLayer, } from 'esri-leaflet';
import { GeocodeServiceProvider, ArcgisOnlineProvider, geosearch } from 'esri-leaflet-geocoder';
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import LocateControl from 'leaflet.locatecontrol';

import DefaultExtent from 'leaflet.defaultextent';
import 'leaflet.defaultextent/dist/leaflet.defaultextent.css';

import 'leaflet';
import Color from 'color';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import request from 'r2';
import { centerOfMass, } from '@turf/turf';

import IdentifyService from './IdentifyService';

const name = 'StandardMap';

export default {
  name,

  components: { IdentifyService, },

  props: {

    features: {
      type: [Array],
      required: false,
      default: () => null,
    },

    selected: {
      type: [Array, Object],
      required: false,
      default: () => null,
    },

    canIdentify: {
      type: Boolean,
      required: false,
      default: true,
    },

    disableBasemapStack: {
      type: Boolean,
      required: false,
      default: false,
    },

    symbolizedLayer: {
      type: Boolean,
      required: false,
      default: false,
    },

    legend: {
      type: Boolean,
      required: false,
      default: false,
    },

    scale: {
      type: Boolean,
      required: false,
      default: true,
    },

    id: {
      type: [String, Number],
      required: false,
    },

    useIdentify: {
      type: Boolean,
      required: false,
      default: true,
    },

    trackMapView: {
      type: Boolean,
      required: false,
      default: true,
    },

    minWidth: {
      type: [String, Number],
      required: false,
      default: 200,
    },

    minHeight: {
      type: [String, Number],
      required: false,
      default: 300,
    },

    maxHeight: {
      type: [String, Number],
      required: false,
      default: null,
    },

    height: {
      type: [String, Number],
      required: false,
      default: null,
    },

    searchBar: {
      type: Boolean,
      required: false,
      default: false,
    },

    progressCursor: {
      type: Boolean,
      required: false,
      default: false,
    },

    // symbols: {
    //   type: Object,
    //   required: false,
    // },

    paddingBottomRight: {
      type: Array,
      required: false,
    },

  },

  data() {
    return {
      flags: {
        busy: false,
      },
      map: null,
      center: [37.260938, -117.649841],
      zoom: 8,
      symbols: null,
      colorScale: ['ghostwhite', 'red', 'blue', 'purple'],
      marker: null,
      locateControl: null,
      primaryLayer: null,
      identifyPointComponentLayer: null,
      pulseIcon: L.icon.pulse({
        iconSize: [18, 18],
        color: 'red',
        fillColor: 'red',
        heartbeat: 1.5,
      }),

      attribution: '<a href="https://www.esri.com/">Esri</a> Tile Services',

    };
  },

  async created() {
    const url = 'https://gis.mono.ca.gov/webgis/rest/services/OpenData/CommunicationPlanning/MapServer/11?f=json';
    const response = await request(url).json;
    // this.symbols = response.drawingInfo.renderer.uniqueValueInfos;
    this.symbols = groupBy(response.drawingInfo.renderer.uniqueValueInfos, 'symbol.color');
  },

  async mounted() {
    // console.warn('component:mounted');
    if (this.$route.query.lat && this.$route.query.lng) {
      this.center = [
        Number(this.$route.query.lat),
        Number(this.$route.query.lng),
      ];
    }

    if (this.$route.query.zoom) {
      this.zoom = Number(this.$route.query.zoom);
    }

    this.$store.commit('SET_IDENTIFY_POINT', null);
  },

  updated() {
  },

  watch: {

    selected(feature) {
      const bounds = GeoJSON.geometryToLayer(feature).getBounds();
      this.$nextTick(() => {
        this.map.fitBounds(bounds);
      });
    },

    identifyPoint() {
      this.centerOnIdentifyPoint();
    },

    progressCursor(value) {
      if (value) {
        DomUtil.addClass(this.map._container, 'cursor-progress');
      } else {
        DomUtil.removeClass(this.map._container, 'cursor-progress');
      }
    },

  },

  computed: {

    serviceAreas() {
      return this.$store.state.data.serviceAreas;
    },

    identifyPoint() {
      return this.$store.state.mapping.identifyPoint;
    },

    mapScale() {
      if (this.zoom <= 9) {
        return 'small';
      } else if (this.zoom <= 14) {
        return 'medium';
      } else {
        return 'large';
      }
    },

    mapElStyle() {
      return {
        width: '100%',
        height: '100%',
        minWidth: `${this.minWidth}px`,
        minHeight: `${this.minHeight}px`,
        maxHeight: `${this.maxHeight}px`,
      };
    },

  },

  methods: {

    identifyPointComponentReady(layer) {
      console.log('identifyPointComponentReady');
      this.identifyPointComponentLayer = layer;
      this.centerOnIdentifyPoint();
    },

    resize() {
      if (this.map) {
        setTimeout(() => {
          this.map.invalidateSize();
        }, 500);
      }
    },

    centerOnIdentifyPoint() {
      if (this.identifyPointComponentLayer) {
        const currentZoom = this.map.getZoom();
        const newZoom = this.map.getZoom() < 11 ? 11 : this.map.getZoom();
        this.$nextTick(() => {
          this.map.invalidateSize();
          const retractedBounds = this.map.getBounds().pad(-0.15);
          if (!retractedBounds.contains(this.identifyPoint) || currentZoom < newZoom) {
            this.map.setView(this.identifyPoint, newZoom);
          }
        });

      }
    },

    handleMapClick({ latlng }) {
      if (this.canIdentify) {
        this.$store.dispatch('identifyPoint', { latlng });
      }
    },

    setServiceAreaRenderer(layer) {
      let min;
      let max;

      const mapped = uniqBy([...this.symbols], 'label')
        .filter(item => item.label !== '<Null>')
        .map((item) => {
          if (item.label.includes('> ')) {
            min = Number(item.label.split('> ')[1]);
          } else {
            min = Number(item.label.split('-')[0]);
            max = Number(item.label.split('-')[1]);
          }
          return {
            color: item.symbol.color,
            min,
            max,
          };
        });

      // console.log(mapped[0]);

      if (layer) {
        layer.eachLayer((layer,) => {
          const speed = layer.feature.properties.Speeds_mbps;
          // console.log(layer);
          // console.log(layer.feature);

          const color = mapped.find(colors => speed >= colors.min && (speed <= colors.max || colors.max === undefined));

          const rgb = color ? `rgba(${color.color.join(',')})` : null;
          // console.log(`${color.min}, ${color.max}`);
          // console.log(rgb);

          layer.setStyle({
            color: color ? rgb : 'black',
          });

          layer.bindPopup(`${speed} ${rgb} ${color.min} ${color.max}`);
        });
      }
    },

    mapReady(map) {
      /*
       Streets, Topographic, NationalGeographic, Oceans, Gray, DarkGray, Imagery,
       ImageryClarity, ImageryFirefly, ShadedRelief, Terrain, USATopo, Physical
     */
      this.map = map;
      this.$emit('map-ready', map);
      map.invalidateSize();

      if (this.symbolizedLayer) {
        new DynamicMapLayer({
          url: 'https://gis.mono.ca.gov/webgis/rest/services/OpenData/CommunicationPlanning/MapServer',
          layers: [11],
          minZoom: 7,
          maxZoom: 12,
          format: 'PNG24', // PNG32,PNG24,PNG,JPG,DIB,TIFF,EMF,PS,PDF,GIF,SVG,SVGZ,BMP
          opacity: 0.85,
          layerDefs: {
            11: 'Location <> \'Regional Service\'',
          },
        }).addTo(map);
      }

      // this.addBoundaries(map);

      //   map.fire('click', {
      //     latlng: {
      //       lat: 37.26530995561875,
      //       lng: -118.24925042664313
      //     }
      //   },);

      new DefaultExtent().addTo(map);

      const monoService = new GeocodeServiceProvider({
        url: 'https://gis.mono.ca.gov/webgis/rest/services/Address_Composite/GeocodeServer',
        maxResults: 20,
      });

      const agol = new ArcgisOnlineProvider({
        countries: 'USA',
      });

      if (this.searchBar) {
        geosearch({
          position: 'topright',
          providers: [monoService, agol,].reverse(),
          useMapBounds: false,
          collapseAfterResult: false,
          expanded: true,
          title: 'stfsdfdsf',
          // placeholder: '',
        }).addTo(map);
      }

      if (this.locate) {
        this.locateControl = new LocateControl({
          position: 'topright',
          iconElementTag: 'i',
          icon: 'mdi mdi-crosshairs-gps',
          iconLoading: 'mdi mdi-crosshairs-gps mdi-spin',
          // keepCurrentZoomLevel: true,
          locateOptions: {
            maxZoom: 15,
            enableHighAccuracy: true,
          },
        }).addTo(map);

      }

    },

    handleLocationFound({ target, latlng }) {
      this.$store.commit('SET_IDENTIFY_POINT', latlng);

      // this.$nextTick(() => {
      //   target.fire('click', {
      //     latlng: latlng,
      //   });
      // });
    },

    updateMapQueryParams() {
      // if (this.trackMapView && this.map) {
      // const { lat, lng } = this.map.getCenter();
      // const zoom = this.map.getZoom();
      // this.$router.push({
      //   params: this.$route.params,
      //   query: {
      //     ...this.$route.query,
      //     zoom,
      //     lat: lat.toFixed(5),
      //     lng: lng.toFixed(5),
      //   }
      // });
      // }
    },

    zoomToAll() {
      if (this.primaryLayer) {
        this.map.fitBounds(this.primaryLayer.getBounds().pad(0.1));
      }
    },

    fitBoundsSpecified(bounds) {
      if (bounds) {
        this.map.fitBounds(bounds);
      } else {
        console.warn('No bounds specified.');
      }
    },

    setViewSpecified(center, zoom = 15) {
      if (center && zoom) {
        this.map.setView(center, zoom);
      } else {
        console.warn('Either no zoom or no center specified!');
      }
    },

    invalidateSize() {
      if (this.map) {
        this.map.invalidateSize();
      }
    },

    getSymbolColor(colorObject) {
      const r = [...colorObject];
      // r.pop();
      return Color(r);
    },

    addBoundaries(map) {
      const url = 'https://gis.mono.ca.gov/webgis/rest/services/OpenData/Boundaries/MapServer/20';

      this.labelGroup = new FeatureGroup({
        minZoom: 8,
        maxZoom: 15,
      });
      this.labelGroup.addTo(map);

      this.boundaries = new FeatureLayer({
        url,
        minZoom: 8,
        maxZoom: 15,
        onEachFeature: (feature) => {
          const labelPoint = centerOfMass(feature.geometry);
          new Marker(labelPoint.geometry.coordinates.reverse(), {
            icon: new DivIcon({
              className: 'text-labels',
              html: feature.properties.CountyName,
            }),
            zIndexOffset: 1000,
          }).addTo(this.labelGroup);
        },
      }).addTo(map);

      this.boundaries.setStyle({
        color: '#c0c0c0',
        fill: false,
        weight: 1,
      });
    },

  },

};
</script>

<style lang="scss">

  @import '../../../node_modules/leaflet.locatecontrol/src/L.Control.Locate';


</style>
